
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class SupersedableProductPlanDtoModel extends Model<SupersedableProductPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'string' },
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'remainingValue', type: 'number' },
		{ name: 'maxAdjustmentValue', type: 'number' },
		{ name: 'suspended', type: 'boolean' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public accountingPlanId?: string;
	public remainingValue: number;
	public maxAdjustmentValue: number;
	public suspended: boolean;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.accountingPlanId = undefined;
		this.remainingValue = 0;
		this.maxAdjustmentValue = 0;
		this.suspended = false;
		
	}
	getProperties(){
		return SupersedableProductPlanDtoModel.classProperties;
	}
}

